import styled, { css } from 'styled-components'
import Skeleton from '@app.components/Skeleton'

const AnalysisResultItemSkeleton = () => (
  <StyledWrapper>
    <Skeleton width={60} height={60} />

    <div className="item-info">
      <div className="company-name">
        <Skeleton width={100} height={15} />
      </div>
      <Skeleton width={40} height={10} />
    </div>
  </StyledWrapper>
)

export default AnalysisResultItemSkeleton

const StyledWrapper = styled.li`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 24px;
    height: 92px;
    border-bottom: 1px solid ${theme.background.bg_1};

    &:first-child {
      border-top: 1px solid ${theme.background.bg_1};
    }
    .item-info {
      .company-name {
        margin-bottom: 10px;
      }
    }
  `}
`
